<template>
  <div class='layout'>
    <!-- 二级路由 -->
    <keep-alive exclude="UserHome,SearchPage,UserProfile,UserMessage,UserArticle,UserFans,UserChat,UserFeedback,UserDynimac,UserLogin">
      <router-view></router-view>
    </keep-alive>
    <!-- tab栏 -->
    <van-tabbar route>
      <van-tabbar-item to="/">
        <span>首页</span>
        <template #icon="props">
          <tt-icon :name="props.active ? 'home-sel' : 'home'"/>
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="/question">
        <span>问答</span>
        <template #icon="props">
          <tt-icon :name="props.active ? 'qa-sel' : 'qa'"/>
        </template></van-tabbar-item>
      <van-tabbar-item to="/video">
        <span>视频</span>
        <template #icon="props">
          <tt-icon :name="props.active ? 'video-sel' : 'video'"/>
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="/user">
        <span>我的</span>
        <template #icon="props">
          <tt-icon :name="props.active ? 'mine-sel' : 'mine'"/>
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: 'Layout'
}
</script>

<style scoped lang='less'>
.layout{
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  .van-tabbar {
    background-color: #F7F8FA;
    /deep/ .van-tabbar-item--active {
      color: @ttColor;
      background-color: #F7F8FA;
    }
    /deep/ .van-tabbar-item__icon {
      font-size: 20px;
    }
    /deep/ .van-tabbar-item__text {
      font-size: 10px;
    }
  }
}
</style>
